<template>
  <div></div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data: () => ({}),
  mounted () {},
  watch: {},
  computed: {},
  methods: {}
}
</script>
